<template>
    <div>
        <el-divider>{{title}}</el-divider>
    </div>
</template>

<script>
    export default {
        props:{
            title: {
                type: String,
                default: "家長帳號信息",
            },
        }
    }
</script>

<style lang="scss" scoped>
::v-deep{
    .el-divider__text{
        font-size: 22px;
        color: #EA4C4E;
    }
    .el-divider--horizontal{
        height: 3px;
        background-color: #EA4C4E;
    }
}
</style>